<script>
  // import { Button } from "smelte";
  import { Link } from "svelte-navigator";

  let tools = [
		{ id: 'conceptpv', name: 'Concept-PV', description: 'Genereren concept proces-verbaal, tekenen door betrokkene, downloaden PDF'},
		{ id: 'adr', name: 'ADR-lachgas', description: 'Checklist voor ter plaatse vastleggen overtredingen + genereren concept-verhoor verdachte'},
    { id: 'generator', name: 'Generator', description: 'Genereren tekstblokken of concept-pv, kopieer naar BVH/Word/PDB of download als PDF'},
    { id: 'dyco', name: 'DyCo - nog niet beschikbaar', description: 'Dynamische verkeerscontrole stappen/checklist'},
    { id: 'verkeershufter', name: 'Verkeersgedrag/huftergedrag - nog niet beschikbaar', description: 'Checklists voor verkeersgedrag: gedragingen, sancties/maatregelen'},
    { id: 'fotos', name: 'Fotogereedschappen', description: 'Fotobladgenerator (download als PDF), batchtool afmetingen en groottes aanpassen (download als ZIP)'}
	];
</script>

<main>
  <h1 class="text-xl mx-2 font-bold">
    Kies een tool
  </h1>
  
  <div class="grid grid-cols-1 gap-4 mx-2 sm:grid-cols-2">
    {#each tools as { id, name, description }, i}
    <div class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
      <div class="flex-1 min-w-0">
        <Link to={id}>
          <span class="absolute inset-0" aria-hidden="true"></span>
          <p class="text-sm font-medium text-gray-900">
            {name}
          </p>
          <p class="text-sm text-gray-500">
            {description}
          </p>
        </Link>
      </div>
    </div>
    {/each}
  </div>
</main>
  
<style>
</style>